import { render, staticRenderFns } from "./CronometrosRecebidos.vue?vue&type=template&id=c535a0d2&scoped=true"
import script from "./CronometrosRecebidos.vue?vue&type=script&lang=js"
export * from "./CronometrosRecebidos.vue?vue&type=script&lang=js"
import style0 from "./CronometrosRecebidos.vue?vue&type=style&index=0&id=c535a0d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c535a0d2",
  null
  
)

export default component.exports